import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminDockerInstances = {
  dockerInstances: {
    pageTitle: "实例管理",
    pageSubtitle: "容器实例创建、控制台与镜像固化",
    objects: {
      instance: "实例",
    },
    summary: {
      total: "实例总数：{count}",
      running: "运行中：{count}",
      stopped: "已停止：{count}",
      withWebEndpoint: "有 Web 入口：{count}",
    },
    table: {
      name: commonShortFieldLabels.name,
      kind: "实例类型",
      image: "镜像标识",
      status: commonShortNouns.status,
      webEndpoint: "Web 入口",
      portMapping: "端口映射",
      expiresAt: "过期时间",
      createdAt: commonShortFieldLabels.createdAt,
      actions: "操作",
    },
    dialogs: {
      commitTitle: "基于实例生成镜像",
    },
    form: {
      imageName: "镜像标识",
      imageNameRequired: "请输入镜像标识",
      imageNamePlaceholder: "例如：exam/practical-upload:snapshot-001",
      description: "描述",
      descriptionPlaceholder: "镜像说明",
      tags: "标签（逗号分隔）",
      tagsPlaceholder: "例如：v1.1,practical,web",
    },
    actions: {
      confirm: "确认",
      detailConsole: "详情/控制台",
      start: "启动",
      stop: "停止",
      commitImage: "生成镜像",
    },
    confirmDelete: {
      title: "确认删除该实例？",
    },
    messages: {
      started: "实例已启动",
      stopped: "实例已停止",
      deleted: "实例已删除",
      imageCommitted: "镜像已生成：{name}",
      defaultCommitDescription: "from container {containerId}",
    },
  },
  dockerInstanceCreate: {
    title: "新建实例",
    imagePickerTitle: "选择镜像（名称 / 标识）",
    table: {
      image: "镜像标识",
      declaredPorts: "声明端口",
      effectivePorts: "生效端口",
      description: "描述",
      actions: "操作",
    },
    form: {
      kind: "实例类型",
      kindRequired: "请选择实例类型",
      kindWeb: "Web（映射端口）",
      kindGeneric: "Generic（不映射端口）",
      name: "实例名",
      namePlaceholder: "可选，默认自动生成",
      image: "镜像标识",
      imageRequired: "请选择镜像标识",
      imagePlaceholder: "输入镜像名称或镜像标识搜索",
      chooseFromList: "从镜像名称/标识列表选择",
      chooseImageHint: "支持在弹窗中按镜像名称或镜像标识筛选并回填镜像标识",
      containerPort: "容器内部端口",
      containerPortRequired: "请输入容器内部端口",
      containerPortHint:
        "仅 web 类型有效：会映射为宿主机随机端口（`host_port:container_port`），不是手工指定 host 端口。",
      ttlMinutes: "过期时间（分钟）",
      ttlRequired: "请输入 TTL",
      inputMode: "参数填写方式",
      inputModeForm: "表单模式",
      inputModeJson: "结构化参数模式",
      paramsJson: "结构化参数",
      cpuLimit: "CPU 限额（核）",
      memoryLimit: "内存限额（MB）",
      consoleInteraction: "控制台交互",
      tty: "终端模式 (-t)",
      stdinOpen: "标准输入 (-i)",
      envVars: "环境变量",
      addEnvVar: "添加环境变量",
      envKeyRequired: "请输入变量名",
      envKeyPlaceholder: "变量名（例如 NODE_ENV）",
      envValuePlaceholder: "变量值（例如 production）",
      entrypointArgs: "入口命令参数",
      addEntrypointArg: "添加入口命令参数",
      arg: "参数",
      entrypointArgPlaceholder: "第一项为入口命令，其余为参数",
      commandArgs: "命令参数",
      addCommandArg: "添加命令参数",
      commandArgPlaceholder: "按顺序传入命令参数",
      imageKeywordPlaceholder: "输入镜像名称或镜像标识筛选",
      selectImage: "选择",
    },
    messages: {
      jsonMustBeObject: "JSON 参数必须是对象",
      jsonInvalid: "JSON 格式错误",
      createSuccess: "实例创建成功",
    },
  },
  dockerInstanceDetail: {
    pageTitle: "实例详情",
    notFound: "未找到对应实例。",
    sections: {
      basicInfo: "基础信息",
      callbackInfo: "callback 信息",
      runtimeData: "运行数据",
      webConsole: "网页控制台",
    },
    fields: {
      name: commonShortFieldLabels.name,
      status: commonShortNouns.status,
      containerId: "容器 ID",
      image: "镜像标识",
      kind: "类型",
      webEndpoint: "Web 入口",
      hostPort: "宿主机端口",
      containerPort: "容器端口",
      checkMode: "检测模式",
      ttyStdin: "终端模式 / 标准输入",
      createdAt: commonShortFieldLabels.createdAt,
      updatedAt: commonShortFieldLabels.updatedAt,
      expiresAt: "过期时间",
      mode: "模式",
      scriptPath: "脚本路径",
      callbackUrl: "回调地址",
      callbackToken: "回调令牌",
    },
    console: {
      description:
        "输入一条 Shell 命令在容器内执行（基于 `docker exec -i`，若实例启用了终端模式会附加 `-t`）。",
      placeholder: "例如：id && pwd && ls -la",
      runCommand: "执行命令",
      clearOutput: "清空输出",
      outputPlaceholder: "命令输出将在此显示",
    },
    actions: {
      copyUrl: "复制地址",
      copyToken: "复制令牌",
    },
    messages: {
      execCompleted: "执行完成：{status}",
      emptyValue: "{label}为空",
      copySuccess: "{label}已复制",
      copyFailed: "{label}复制失败",
    },
  },
} as const;
